/**
 * Patches the grid-slider Swiper instance inside this section to use
 * exact integer slidesPerView instead of the default +0.5 peek offset.
 *
 * Reads data-slides-desktop and data-slides-mobile from the element,
 * waits for swiper-initialized on the wrapper, then corrects both
 * swiper.params (current viewport) and swiper.originalParams.breakpoints
 * (so resize events also use the corrected values).
 */
class ProductShowcaseFix extends HTMLElement {
  connectedCallback() {
    const wrapper = this.closest('[data-grid-slider-wrapper]');
    if (!wrapper) return;

    const desktopCount = parseInt(this.dataset.slidesDesktop, 10) || 3;
    const tabletCount = Math.max(desktopCount - 1, 2);
    const mobileCount = parseInt(this.dataset.slidesMobile, 10) || 1;

    const applyFix = () => {
      const gridSlider = wrapper.querySelector('grid-slider');
      const swiper = gridSlider?.swiperInstance;
      if (!swiper) return false;

      // Patch originalParams.breakpoints so Swiper uses correct values after resize
      const origBp = swiper.originalParams?.breakpoints;
      if (origBp?.[768]) origBp[768].slidesPerView = tabletCount;
      if (origBp?.[1024]) origBp[1024].slidesPerView = desktopCount;

      // Patch current params.breakpoints too
      const bp = swiper.params?.breakpoints;
      if (bp?.[768]) bp[768].slidesPerView = tabletCount;
      if (bp?.[1024]) bp[1024].slidesPerView = desktopCount;

      // Apply correct value for the current viewport immediately
      const vw = window.innerWidth;
      if (vw >= 1024) {
        swiper.params.slidesPerView = desktopCount;
      } else if (vw >= 768) {
        swiper.params.slidesPerView = tabletCount;
      } else {
        swiper.params.slidesPerView = mobileCount === 1 ? 1.08 : 1.5;
      }

      swiper.update();
      return true;
    };

    if (wrapper.classList.contains('swiper-initialized')) {
      applyFix();
      return;
    }

    const observer = new MutationObserver(() => {
      if (wrapper.classList.contains('swiper-initialized') && applyFix()) {
        observer.disconnect();
      }
    });

    observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
  }
}

if (!customElements.get('product-showcase-fix')) {
  customElements.define('product-showcase-fix', ProductShowcaseFix);
}
